import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CardModel } from 'data/card/card.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: CardModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<CardModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const cardSlice = createSlice({
  name: 'card',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default cardSlice;
